module.exports = __webpack_public_path__ + "static/media/consultorio-07.b620e0b0.JPG";